import * as Yup from "yup";

export const createOrderValidation = Yup.object().shape({
  patient: Yup.object().shape({
    phoneNumber: Yup.string()
      .matches(/^\d{10}$/, "Number must be 10 digits")
      .required("Phone number is required"),
    name: Yup.string().notRequired(),
    surname: Yup.string().notRequired(),
    gender: Yup.string().required("Gender is required"),
    dateofbirth: Yup.date().when('age', {
      is: (age) => !age || age.toString().trim().length === 0,
      then: () => Yup.date().required("Date of birth is required"),
      otherwise: () => Yup.date().notRequired().nullable(),
    }),
    age: Yup.number().positive("Age must be positive").typeError("Age must be a number").when('dateofbirth', {
      is: (dob) => !dob,
      then: () => Yup.number().required("Age is required").typeError("Age must be a number"),
      otherwise: () => Yup.number().notRequired().nullable(),
    }),
    pincode: Yup.string().when('city', {
      is: (city) => !city || city.toString().trim().length === 0,
      then: () => Yup.string().required("Pincode is required").matches(/^\d{6}$/, "Must be a 6 digit pincode"),
      otherwise: () => Yup.string().notRequired(),
    }),
    city: Yup.string().when('pincode', {
      is: (pincode) => !pincode || pincode.toString().trim().length === 0,
      then: () => Yup.string().required("City is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
  }, [['pincode', 'city'], ['dateofbirth', 'age']]),
});
export const createStoreOrderValidation = Yup.object().shape({
  patient: Yup.object().shape({
    phoneNumber: Yup.string()
      .matches(/^\d{10}$/, "Number must be 10 digits")
      .required("Phone number is required"),
    name: Yup.string().notRequired(),
    surname: Yup.string().notRequired(),
    dateofbirth: Yup.date().when('age', {
      is: (age) => !age || age.toString().trim().length === 0,
      then: () => Yup.date().required("Date of birth is required"),
      otherwise: () => Yup.date().notRequired().nullable(),
    }),
    age: Yup.number().positive("Age must be positive").typeError("Age must be a number").when('dateofbirth', {
      is: (dob) => !dob,
      then: () => Yup.number().required("Age is required").typeError("Age must be a number"),
      otherwise: () => Yup.number().notRequired().nullable(),
    }),
    pincode: Yup.string().when('city', {
      is: (city) => !city || city.toString().trim().length === 0,
      then: () => Yup.string().required("Pincode is required").matches(/^\d{6}$/, "Must be a 6 digit pincode"),
      otherwise: () => Yup.string().notRequired(),
    }),
    city: Yup.string().when('pincode', {
      is: (pincode) => !pincode || pincode.toString().trim().length === 0,
      then: () => Yup.string().required("City is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
  }, [['pincode', 'city'], ['dateofbirth', 'age']]),
  DID: Yup.string().required("Doctor Name is required"),
});
let doctorCreateObj = {
  doctorDetails: Yup.object().shape({
    contactNumber: Yup.string()
      .required("Contact number is required")
      .matches(/^\d{10}$/, "Contact number must be 10 digits"),
    pin: Yup.string()
      .required("PIN A is required")
      .matches(/^\d+$/, "PIN must contain digits only (0–9)")
      .min(5, "PIN must be at least 5 digits")
      .max(5, "PIN must be 5 digits long"),
    pinB: Yup.string()
      .required("PIN B is required")
      .matches(/^\d+$/, "PIN must contain digits only (0–9)")
      .min(5, "PIN must be at least 5 digits")
      .max(5, "PIN must be 5 digits long")
      .test(
        "pins-not-equal",
        "PIN B cannot be the same as PIN A",
        function (value) {
          return value !== this.parent.pin;
        }
      ),
  }),
  compliances: Yup.object().shape({
    gstNumber: Yup.string()
      .matches(
        /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9]{1}[Z]{1}[0-9A-Z]{1}$/,
        "Invalid GST Number"
      ), // Example regex, adjust as needed
    registrationNumber: Yup.string().required(
      "Registration Number is required"
    ),
  }),
  accountCategory: Yup.object().shape({
    category: Yup.string().required("Category is required"),
  }),
  personalInfo: Yup.object().shape({
    name: Yup.string().required("Name is required"),
    surname: Yup.string().required("Surname is required"),
    clinicName: Yup.string().required("Clinic Name is required"),
    qualificationSpecialisation: Yup.string().required(
      "Qualification is required"
    ),
    experience: Yup.number()
      .required("Experience is required")
      .min(0.5, "Minimum 6 month experience is required."),
    about1: Yup.string().test(
      "max-words",
      "Maximum 120 words allowed",
      (value) => !value || value.trim().split(/\s+/).length <= 120
    ),
    about2: Yup.string().test(
      "max-words",
      "Maximum 120 words allowed",
      (value) => !value || value.trim().split(/\s+/).length <= 120
    ),
    // experience: Yup.string()
    //   .required("Experience is required")
    //   .test("is-number", "Minimum 6 month experience is required", (value) => {
    //     // Check if the value is a valid number
    //     const numValue = parseFloat(value);
    //     return !isNaN(numValue) && numValue >= 0.5; // validate that the number is at least 0.5 (6 months)
    //   })
    //   .matches(/^\d+(\.\d{1,2})?$/, "Minimum 6 month experience is required."), // Optional: to enforce a valid number format
  }),
  clinicAddress: Yup.object().shape({
    premisesNo: Yup.string().required("Premises No is required"),
    floor: Yup.string(),
    premisesName: Yup.string().required("Premises Name is required"),
    areaRoad: Yup.string().required("Area/Road is required"),
    city: Yup.string().required("City is required"),
    pinCode: Yup.string()
      .required("PIN Code is required")
      .matches(/^\d{6}$/, "Invalid PIN Code"),
    state: Yup.string().required("State is required"),
    googleMapUrl: Yup.string()
      .url("Invalid URL")
      .required("google Map Url is required"),
    clinicContactNumber: Yup.string().matches(
      /^\d{10}$/,
      "Contact number must be 10 digits"
    ),
  }),
  emailInfo: Yup.object().shape({
    doctorEmail: Yup.string().email("Invalid email"),

    clinicEmail: Yup.string().email("Invalid email"),
  }),

  paymentDetails: Yup.object().shape({
    bankAccountNumber: Yup.string().required("Bank Account Number is required"),
    accountName: Yup.string().required("Account Holder Name is required"),
    bankName: Yup.string().required("Bank Name is required"),
    ifscName: Yup.string().required("IFSC Code is required"),
    // upiId: Yup.string().required("UPI ID is required"),
  }),
};
export const createDoctorValidation = () =>
  Yup.object().shape({
    ...doctorCreateObj,
    paymentDetails: Yup.object().shape({
      bankAccountNumber: Yup.string().required(
        "Bank Account Number is required"
      ),
      // .matches(bankAccountNumberRegex, "Invalid Bank Account Number"),
      accountName: Yup.string().required("Account Holder Name is required"),
      bankName: Yup.string().required("Bank Name is required"),
      ifscName: Yup.string()
        .required("IFSC Code is required")
        .matches(/^[A-Za-z]{4}[0-9]{7}$/, "Invalid IFSC Code"),
    }),
  });
export const upiValidation = Yup.object().shape({
  ...doctorCreateObj,
  paymentDetails: Yup.object().shape({
    upiId: Yup.string().required("UPI ID is required"),
  }),
});

export const createStoreValidation = Yup.object().shape({
  storeDetails: Yup.object().shape({
    title: Yup.string().required("Store title is required"),
    username: Yup.string()
      .required("Username is required")
      .matches(/^\S*$/, "Username should not contain spaces"),
    pin: Yup.string()
      .matches(/^\d+$/, "PIN must contain digits only (0–9)")
      .min(6, "PIN must be at least 6 digits")
      .max(6, "PIN must be exactly 6 digits")
      .required("PIN is required"),
  }),
  address: Yup.object().shape({
    premisesNo: Yup.string().required("Premises number is required"),
    premisesName: Yup.string().required("Premises name is required"),
    city: Yup.string().required("City is required"),
    pinCode: Yup.string()
      .required("Pin code is required")
      .matches(/^\d{6}$/, "Invalid PIN Code"),
    state: Yup.string().required("State is required"),
    // landmark: Yup.string().required("landmark is required"),
    areaRoad: Yup.string().required("Area/road is required"),
    phoneNumber: Yup.string().matches(
      /^\d{10}$/,
      "Contact number must be 10 digits"
    ),
  }),
  // compliances: Yup.object().shape({
  //   gstin: Yup.string()
  //     .matches(
  //       /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9]{1}[Z]{1}[0-9A-Z]{1}$/,
  //       "Invalid GST Number"
  //     ) // Example regex, adjust as needed
  //     .required("GST Number is required"),
  // }),
  contact: Yup.object().shape({
    contactNo: Yup.string()
      .matches(/^\d{10}$/, "Contact number must be 10 digits")
      .required("Contact number is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    email2: Yup.string().email("Invalid email"),
  }),
  location: Yup.object().shape({
    googleMapUrl: Yup.string()
      .required("Google map url is required")
      .url("Invalid URL format"),
  }),
});

// storeId: Yup.string().required('Store ID is required'),
export const createProductValidation = Yup.object().shape({
  // productId: Yup.string().required('Product ID is required'),
  productName: Yup.string().required("Product name is required"),
  manufacturer: Yup.string().required("Manufacturer is required"),
  // units: Yup.number()
  //   .typeError("Units must be a number")
  //   .min(0, "Units must be a positive number"),
  units: Yup.number()
    .positive("Stock must be a positive number")
    .required("Stock value is required"),
  // .positive("Units must be a positive number"),
  uom: Yup.number()
    .typeError("Units of medicine must be a number")
    .required("Unit value is required")
    .positive("Units must be a positive number"),
  storeQty: Yup.array()
    .of(
      Yup.object().shape({
        storeId: Yup.string().nullable(),

        // Qty: Yup.number()
        //   .nullable()
        //   .test("maxQty", "Qty cannot be greater than unit", function (value) {
        //     const { units } = this.options.context;
        //     const currentStoreId = this.parent.storeId;
        //     const unitsofstore = units[currentStoreId];
        //     console.log(
        //       currentStoreId,
        //       "currentStoreId",
        //       unitsofstore,
        //       "unitsofstore"
        //     );
        //     if (unitsofstore > 0 && units > 0) {
        //       return value <= units;
        //     } else {
        //       if (units > 0) {
        //         return this.createError({
        //           message: "Store ID is required when Qty is entered",
        //         });
        //       }
        //     }
        //   }),
        Qty: Yup.number()
          .nullable() // Allow Qty to be null or empty
          .test(
            "maxQty",
            "Qty cannot be greater than stock unit",
            function (value) {
              const { units } = this.options.context;
              const currentStoreId = this.parent.storeId;

              // Check if Qty is entered
              if (value != null && value !== "") {
                // Ensure storeId is provided
                if (!currentStoreId && value >= 1) {
                  return this.createError({
                    message: "Store ID is required when Qty is entered",
                  });
                }

                if (value > 0 && units > 0) {
                  return value <= units; // Return true if Qty is valid
                } else {
                  // return this.createError({
                  //   message: "Plase enter stock first.",
                  // });
                }
              }

              // If Qty is empty, skip validation
              return true;
            }
          ),
      })
    )
    .test(
      "totalQty",
      "Total Qty cannot exceed unit value",
      function (storeQty) {
        const { units } = this.options.context;
        const totalQty = storeQty.reduce(
          (sum, item) => sum + (item.Qty || 0),
          0
        );
        return !(units > 0 && totalQty > units);
      }
    ),
  type: Yup.string().required("Type is required"),
  drugs: Yup.array()
    .of(Yup.string())
    .min(1, "At least one drug must be selected"),
  vId: Yup.string()
    .required("Please select a margin option"),
  pricing: Yup.object().shape({
    mrp: Yup.number()
      .positive("MRP must be a positive number")
      .required("MRP is required"),
    gst: Yup.number()
      .min(0, "GST must be 0 or greater")
      .required("GST is required"),
  }),
  images: Yup.array().of(Yup.string()).nullable().notRequired(),
});

export const updateProductValidation = Yup.object().shape({
  // productId: Yup.string().required('Product ID is required'),
  productName: Yup.string().required("Product name is required"),
  manufacturer: Yup.string().required("Manufacturer is required"),
  units: Yup.number()
    .typeError("Units must be a number")
    .required("units are required"),
  uom: Yup.number()
    .typeError("Units of medicine must be a number")
    .positive("Units of medicine must be a positive number")
    .required("Units of medicine are required"),
  moreUnits: Yup.number().nullable().min(0, "Value cannot be negative"),
  removeUnits: Yup.number()
    .nullable()
    .min(0, "Value cannot be negative")
    .test("removeUnits", "Insufficient stock", function (value) {
      const { productStock } = this.options.context || {};
      if (value == null) return true; // Skip validation for null/undefined

      if (value > 0) {
        return value <= productStock;
      }
      return true;
    }),
  storeQty: Yup.array()
    .of(
      Yup.object().shape({
        storeId: Yup.string(),
        moreQty: Yup.number()
          .nullable()
          .test("moreQty", "Insufficient product stock", function (value) {
            const { units } = this.options.context || {};
            const currentStoreId = this.parent.storeId;

            if (value != null && value !== "" && value !== 0) {
              if (!currentStoreId && value >= 1) {
                return this.createError({
                  message: "Store ID is required when Qty is entered",
                });
              }
              if (value > 0 && units > 0) {
                return value <= units;
              }
            } else {
              return true;
            }
          }),
        removeQty: Yup.number()
          .nullable()
          .min(0, "Value cannot be negative")
          .test("removeQty", "Insufficient stock", function (value) {
            const { stock } = this.parent || {};
            if (value == null) return true;
            if (value > 0) {
              return value <= stock;
            }
            return true;
          }),
      })
    )
    .test(
      "totalQty",
      "Total Qty cannot exceed unit value",
      function (storeQty) {
        const { units } = this.options.context;
        const totalQty = storeQty.reduce(
          (sum, item) => sum + (item.moreQty || 0),
          0
        );
        return !(units > 0 && totalQty > units);
      }
    ),
  type: Yup.string().required("Type is required"),
  drugs: Yup.array()
    .of(Yup.string())
    .min(1, "At least one drug must be selected"),
  vId: Yup.string()
    .required("Please select a margin option"),
  pricing: Yup.object().shape({
    mrp: Yup.number()
      .positive("MRP must be a positive number")
      .required("MRP is required"),
    gst: Yup.number()
      .min(0, "GST must be 0 or greater")
      .required("GST is required"),
  }),
  images: Yup.array().of(Yup.string()).nullable().notRequired(),
});

export const trackOrderValidation = Yup.object().shape({
  orderId: Yup.string().required("Please enter order Id").trim(),
  phoneNumber: Yup.string()
    .required("Please enter phone number")
    .matches(/^[6-9]\d{9}$/, "Please enter a valid 10-digit phone number")
    .trim(),
});
